<label [ngClass]="customClass"
       class="input-panel">

  <div class="pt-0.5">
    @if (visualType === 'switch') {
      <div class="switch" role="switch" aria-checked="false">
        <span aria-hidden="true" class="control"></span>
      </div>
    } @else {
      <span class="panel-icon flex rounded-full p-1">
        <i-tabler aria-hidden="true" class="text-white h-4 w-4" name="check" />
      </span>
    }

    <span aria-hidden="true" class="selection"></span>
  </div>
  <input (change)="changed.emit(ref)"
         (click)="selected.emit(ref)"
         [attr.aria-describedby]="describedby()"
         [attr.aria-labelledby]="labelledby()"
         [checked]="checked"
         [disabled]="disabled"
         [name]="groupName"
         [type]="inputType"
         [value]="ref"
         class="sr-only">
  <span class="flex-1">
    <span class="flex justify-between gap-4">
      <span [id]="labelledby()"
            class="block h5 mb-0 text-gray-900 col-span-2">
        <ng-content select="[label]"></ng-content>
        @if(hasTranslationForKey(moreInfoDescription())) {
          <button (click)="openModal('', moreInfoDescription())"
                  class="btn link ml-2">
            <i-tabler class="h-4 w-4 mr-1" name="info-circle"></i-tabler>
          </button>
        }
      </span>

      @if (isPartOfPackage()) {
        <span [id]="describedby()" class="block text-gray-900 text-right flex-shrink-0">
            <span class="h5 mb-0">{{ 'common.label.included' | translate }}</span>
        </span>
      } @else {
        @if (discount(); as discount) {
          @if ( price >= 0) {
            <webmodule-order-discount-price [describedby]="describedby()"
                                            [price]="price"
                                            [isOneTimePayment]="isOneTimePayment"
                                            [discount]="discount" />
          }
        } @else {
          @if (priceAlt || price >= 0) {
            <span [id]="describedby()"
                  class="block text-gray-900 text-right flex-shrink-0">
            <span class="h5 mb-0">{{ price ? (price | currency: 'EUR') : priceAlt }}</span>
              @if (price > 0) {
                <span class="pl-1 h6 mb-0">{{ isOneTimePayment ? 'eenmalig' : '/maand' }}</span>
              }
            </span>
          }
        }
      }
    </span>

    <span class="grid grid-cols-3 gap-4">
      <ng-content select="[content]"></ng-content>
    </span>
  </span>
</label>
